import cx from 'classnames';
import PropTypes from 'prop-types';

import IconPlus from 'src/assets/icons/Plus';
import { CUSTOM_BUTTON_VARIANT, CustomButton } from 'src/components/CustomButton';
import { PROMPT_ACTION } from 'src/data/prompt';

import { ItemsBank } from '../ItemsBank';

import { useStyles } from './useStyles';

const propTypes = {
  className: PropTypes.string,
  bankResources: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  onAction: PropTypes.func.isRequired,
  isApplicationModeInfinity: PropTypes.bool,
  quickSearchMode: PropTypes.bool,
  noTags: PropTypes.bool,
};

const defaultProps = {
  className: '',
  isApplicationModeInfinity: false,
  quickSearchMode: false,
  noTags: false,
};

export const MenuContentBank = ({
  className,
  bankResources,
  onAction,
  isApplicationModeInfinity,
  quickSearchMode,
  noTags,
}) => {
  const styles = useStyles();

  return (
    <div className={cx(styles.root, className)}>
      <CustomButton
        onClick={() => onAction(PROMPT_ACTION.addBrandBrief)}
        startIcon={<IconPlus />}
        variant={CUSTOM_BUTTON_VARIANT.outlined}
        data-testid="addNewMessagingBankButton"
      >
        Add new
      </CustomButton>

      <ItemsBank
        bankResources={bankResources}
        onAction={onAction}
        isApplicationModeInfinity={isApplicationModeInfinity}
        quickSearchMode={quickSearchMode}
        noTags={noTags}
      />
    </div>
  );
};

MenuContentBank.displayName = 'MenuContentBank';
MenuContentBank.propTypes = propTypes;
MenuContentBank.defaultProps = defaultProps;
